<template>
	<div class='HomePoster'>
		<modals-container/>
		<div class='WhatPageContainer'  ref='what_page'>
<!--			<div class="unlockMessage" id="unlockMessage" :class="{hidden: hideUnlock}">Unlock Minimum Standards</div>-->
			<video id='video_bg' playsinline class='WhatBackgroundImage' :class="{ NoDisplay: DisplayVideo }" ref='what_background' autoplay muted loop>
				<source src='assets/animations/modern_factory_internals_loop.mp4' type='video/mp4'>
			</video>
			<div class='PageHeader PageHeaderExtra'>
				<div class='PageHeaderRollsRoyceLogo'></div>
				<div class='PageHeaderTitleContainer'>What</div>

				<div class='PageHeaderButtonContainer' ref='navback_button'>
                    <button class='AcronymsButton' :class="{ AcronymsOnState: acronymsState }" @click="showAcronyms"></button>

					<router-link :to="{ name: 'HomePage' }">
                        <button class='NavBackButton'></button>
                    </router-link>
				</div>
			</div>

			<div class='WhatMenuBasicItemsContainer' :class="{ NoDisplay: DisplayVideo }" ref='what_menu_items'>
<!--				<div class='WhatMenuItems LeftItems'>-->
          <div class="btnRow" style="width: 100%;">
            <ButtonComponent :icon="this.iconService.icons.People" style="fill: #FFFFFF;" text="People (ownership and training)" link="people" font-size="18px">

            </ButtonComponent>
            <ButtonComponent :icon="this.iconService.icons.Tools" text="Tools (PFMEA, control plan, Min Std)" link="tools" font-size="18px" >

            </ButtonComponent>
            <ButtonComponent :icon="this.iconService.icons.Feedback" text="Feedback" link="feedback" font-size="18px"  >

            </ButtonComponent>
<!--          </div>-->
<!--					<router-link :to="{ name: 'BasicCultureHome' }">-->
<!--                        <button class='NavButton NavButtonCultureVision'></button>-->
<!--                    </router-link>-->

<!--					<router-link :to="{ name: 'BasicSystemHome' }">-->
<!--                        <button class='NavButton NavButtonEnterpriseSystems'></button>-->
<!--                    </router-link>-->
				</div>

<!--				<div class='WhatMenuItems RightItems'>-->
<!--          <ButtonComponent :icon="this.iconService.icons.Feedback" text="Feedback" link="feedback" font-size="18px" dir="left" >-->

<!--          </ButtonComponent>-->
<!--          <ButtonComponent :icon="this.iconService.icons.BestPractice" text="Best Practice" link="why" font-size="18px" dir="left" style="margin-top: 50px">-->

<!--          </ButtonComponent>-->
<!--					<router-link :to="{ name: 'BasicITHome' }">-->
<!--                        <button class='NavButton NavButtonITInfrastructure'></button>-->
<!--                    </router-link>-->

<!--					<router-link :to="{ name: 'BasicDigitalHome' }">-->
<!--                        <button class='NavButton NavButtonDigitalIntero'></button>-->
<!--                    </router-link>-->
<!--				</div>-->
			</div>
<!--			<video id='video' playsinline class='WhatVideoContainer HomePoster' :class="{ NoDisplay: !DisplayVideo }" ref='what_video' poster="assets/img/poster_home.a1966c69.png" @click="closedVideo" @ended="closedVideo" muted autoplay>-->
<!--				<source src='assets/animations/old_modern_zoom.mp4' type='video/mp4'>-->
<!--			</video>-->
		</div>
	</div>
</template>

<script>
	import CodeModal from '../modals/CodeModal';
	import AcronymsModal from '../modals/AcronymsModal';
  import ButtonComponent from "../ui/ButtonComponent";
  import iconService from "../../services/iconService";

	export default {
		data () {
			return {
				acronymsState: false,
				loginState: false,
				unlockedState: false,
				requestState: false,
				DisplayVideo: true,
				DisplayHomeGB: false,
				hideUnlock:false,
        iconService: iconService
			}
		},

		created () {
			this.init();
		},

		methods: {
			init() {
				let getUnloadState = localStorage.getItem("UnlockMode");
				
				// Set UnlockedState, Based On LocalStorage
				if (getUnloadState === 'true') {
					this.unlockedState = true;
					this.hideUnlock = true;
				}

				// Check To See If Video Needs Playing
				this.videoPlay();
			},

			closedVideo () {
				this.DisplayVideo = false;

				// Set Local Var To True, Once Video Has Play or Clicked Close
				localStorage.setItem("ZoomVideoPlayed", true);
			},

			videoPlay () {
				let GetVideoSetting = localStorage.getItem("ZoomVideoPlayed");

				if (GetVideoSetting === 'true') {
					this.DisplayVideo = false;
				}
			},

			showAcronyms() {
				// Open Acronyms Modal 'LightOut' Box
				this.$modal.show(AcronymsModal, {}, {
					width: "100%",
					height: "auto",
					// maxWidth: "auto"
				},{
					'before-close': () => { this.acronymsState = !this.acronymsState }
				});

				this.acronymsState = !this.acronymsState
			},

			showCode() {
				// Open Acronyms Modal 'LightOut' Box
				this.$modal.show(CodeModal, {}, {
					width: "100%",
					height: "auto"
				},{
					'before-close': () => { this.loginState = !this.loginState }
				});

				this.loginState = !this.loginState;

				var GetLockedState = localStorage.getItem("UnlockMode");

				if(GetLockedState == true) {
					this.unlockedState = true;
				}
			},
		},
    components:{
      ButtonComponent
    }

	}
</script>
<style scoped>
.btnRow{
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
}
</style>